import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { clientStore } from 'apps/client/app';

import { Link, ExternalLink } from 'core/routing';
import { inWhitelabel } from 'core/whitelabel';

import { conf } from 'apps/components/footer/config.yaml';
import websiteRoutes from 'apps/components/header/config';

import Copyright from 'apps/components/footer/blocks/Copyright';
import Social from 'apps/components/footer/blocks/Social';
import ChinaICP from 'apps/components/footer/blocks/ChinaICP';
import ChinaMPSBRecord from 'apps/components/footer/blocks/ChinaMPSBRecord';
import FooterSmall from 'apps/components/footer/footerSmall';

import {
  FooterMainStyled,
  FooterNav,
  RoutesContent,
  LogoStyled,
  LogoWrapper,
  LogoWrapperChild,
  CopyrightHeader,
  PrimaryNav,
  FooterInceptionMainWrapper,
  FooterInceptionWrapper,
  FooterColumnWrapper,
  ChinaIDsColumn,
} from './footer.styled';

const noFooterSegments = [
  'home.newStory',
  'home.newProject',
  'home.newInitiative',
  'home.signIn',
  'home.signUp',
  'home.signUpOrganisation',
  'home.signUpManufacturer',
  'home.fabservices',
  'home.newPassword',
  'home.signUpByEmail',
  'home.invitations',
  'home.gateway',
  'home.importProject',
  'viewer',
  'profile.project.file',
  'profile.project.version.file',
  'initialive.project.file',
  'initialive.project.version.file',
  'workspace.share-file',
  'workspace.make-part',
  'workspace.make-part.file',
  'rfq',
  'order',
  'onboarding.choosePlan',
  'onboarding.confirmProfile',
  'onboarding.checkEmail',
];

const Footer = () => {
  const { signedInProfile } = clientStore;
  const primaryNavLinks = Array.from(conf.primaryNav.entries());
  const secondaryNavLinks = Array.from(conf.secondaryNav.entries());
  const chinaMode = window.location.hostname.split('.').pop() === 'cn';

  if (inWhitelabel()) secondaryNavLinks.splice(0, 1);

  if (
    clientStore.routeSegments[2] === 'settings' ||
    clientStore.routeSegments[1] === 'help' ||
    clientStore.footerHidden ||
    noFooterSegments?.includes(clientStore.routerStore.route.name)
  ) {
    return null;
  }

  const homeRouteLogOut =
    clientStore.routerStore.route.name === 'home' && !signedInProfile;
  const showLargeFooter =
    !inWhitelabel() &&
    (homeRouteLogOut ||
      websiteRoutes?.includes(clientStore.routerStore.route.name));

  const RoutesList =
    showLargeFooter &&
    (() => {
      return (
        <RoutesContent>
          {primaryNavLinks.map(([index, item]) => {
            return (
              <PrimaryNav key={index}>
                <dt>
                  <Trans>{item.text}</Trans>
                </dt>
                {item.items.length > 0 &&
                  item.items.map(subItem => (
                    <dd key={subItem.text}>
                      {subItem?.link?.includes('http') ? (
                        <ExternalLink to={subItem.link}>
                          <Trans>{subItem.text}</Trans>
                        </ExternalLink>
                      ) : (
                        <Link
                          name={subItem.link}
                          to={subItem.link}
                          params={subItem.params}
                        >
                          <Trans>{subItem.text}</Trans>
                        </Link>
                      )}
                    </dd>
                  ))}
              </PrimaryNav>
            );
          })}
        </RoutesContent>
      );
    });

  if (!showLargeFooter) return <FooterSmall chinaMode={chinaMode} />;

  return (
    <FooterMainStyled>
      <FooterNav>
        <FooterInceptionMainWrapper>
          <LogoWrapper>
            <LogoWrapperChild>
              <LogoStyled negativeVersion />
            </LogoWrapperChild>
            <CopyrightHeader>
              {chinaMode && (
                <ChinaIDsColumn mobile>
                  <ChinaICP mobile hiddenMediumToLarge />
                  <ChinaMPSBRecord mobile hiddenMediumToLarge />
                </ChinaIDsColumn>
              )}
              <Copyright />
            </CopyrightHeader>
          </LogoWrapper>
          <FooterColumnWrapper>
            <RoutesList />
            <FooterInceptionWrapper>
              <Copyright main />
              {chinaMode && (
                <ChinaIDsColumn>
                  <ChinaICP main />
                  <ChinaMPSBRecord main />
                </ChinaIDsColumn>
              )}
              <Social hideText />
            </FooterInceptionWrapper>
          </FooterColumnWrapper>
        </FooterInceptionMainWrapper>
      </FooterNav>
    </FooterMainStyled>
  );
};

export default withNamespaces()(observer(Footer));
